var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"dependent-benefits",attrs:{"items":_vm.dependents,"no-data-text":"Não há dependentes","headers":_vm.headers,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.healthPlanDependent",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBoolean(item.healthPlanDependent))+" ")]}},{key:"item.healthPlanDependentPayedByDB1",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBoolean(item.healthPlanDependentPayedByDB1))+" ")]}},{key:"item.type",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatHealthPlanRegion(item.type))+" ")]}},{key:"item.dentalPlanDependent",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBoolean(item.dentalPlanDependent))+" ")]}},{key:"item.dentalPlanDependentPayedByDB1",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatBoolean(item.dentalPlanDependentPayedByDB1))+" ")]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }